<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="title">QR Code Generator</h4>
      </div>
      <div class="card-content row">
        <form method="get" action="#" v-on:submit.prevent class="form-horizontal">
          <fieldset>
            <div class="form-group">
              <label class="col-sm-2 control-label">QR Code Value</label>
              <div class="col-sm-10">
                <input type="text" name="proposed_code_value" v-model="proposed_code_value" class="form-control" />
              </div>
            </div>
          </fieldset>

          <button type="submit" @click.prevent="makeQrcode()" class="btn btn-fill btn-info">Make QR Code</button>
        </form>
        <hr />
        <qrcode v-if="!!code_value" :value="code_value" :options="{ size: 200 }"></qrcode>
      </div>
    </div>
  </div>
</template>
<script>
  

  export default{
    data () {
      return {
        proposed_code_value: '',
        code_value: ''
      }
    },
    methods: {
      makeQrcode () {
        this.code_value = this.proposed_code_value
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Code.vue